import { render, staticRenderFns } from "./ExternalCommentContent.vue?vue&type=template&id=37bb6579&scoped=true&"
import script from "./ExternalCommentContent.vue?vue&type=script&lang=ts&"
export * from "./ExternalCommentContent.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalCommentContent.vue?vue&type=style&index=0&id=37bb6579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bb6579",
  null
  
)

export default component.exports